/**
 * Safe Global Objects
 * Only expose safe, read-only built-in objects
 */

export const SAFE_GLOBALS = {
  // Math (all methods are safe)
  Math,

  // JSON (parse and stringify only)
  JSON: {
    parse: JSON.parse,
    stringify: JSON.stringify,
  },

  // Array utilities (no mutating prototype methods exposed)
  Array: {
    isArray: Array.isArray,
    from: Array.from,
    of: Array.of,
  },

  // Object utilities (no prototype manipulation)
  Object: {
    keys: Object.keys,
    values: Object.values,
    entries: Object.entries,
    fromEntries: Object.fromEntries,
    assign: Object.assign,
  },

  // String utilities
  String: {
    fromCharCode: String.fromCharCode,
    fromCodePoint: String.fromCodePoint,
  },

  // Number utilities
  Number: {
    isNaN: Number.isNaN,
    isFinite: Number.isFinite,
    isInteger: Number.isInteger,
    isSafeInteger: Number.isSafeInteger,
    parseFloat: Number.parseFloat,
    parseInt: Number.parseInt,
    MAX_VALUE: Number.MAX_VALUE,
    MIN_VALUE: Number.MIN_VALUE,
    MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    MIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    POSITIVE_INFINITY: Number.POSITIVE_INFINITY,
    NEGATIVE_INFINITY: Number.NEGATIVE_INFINITY,
    NaN: Number.NaN,
  },

  // Date (full support)
  Date,

  // Boolean
  Boolean,

  // Global functions
  parseInt,
  parseFloat,
  isNaN,
  isFinite,
  encodeURI,
  decodeURI,
  encodeURIComponent,
  decodeURIComponent,

  // Promise (for async/await)
  Promise,

  // Error types (for error handling)
  Error,
  TypeError,
  ReferenceError,
  SyntaxError,
  RangeError,

  // Literals
  undefined,
  NaN,
  Infinity,

  // Console (output only)
  console: {
    log: (...args) => console.log('[Sandbox]', ...args),
    warn: (...args) => console.warn('[Sandbox]', ...args),
    error: (...args) => console.error('[Sandbox]', ...args),
  },
}

/**
 * Create globals with injected tools
 */
export function createGlobals(tools) {
  return {
    ...SAFE_GLOBALS,
    tools,
  }
}
